import { types } from '../_actionTypes/search';

export function set(url: string, callback: (text: string) => void) {
  return {
    type: types.SEARCH_SET,
    callback,
    url,
  };
}
